export const TEST_EMAILS = [
  'test@test.com',
  'test@example.com',
  'noah@charliescrew.com',
  'jonas@charliescrew.com',
  'konstantin@charliescrew.com',
  'chiara@charliescrew.com',
  'tech@genie-ops.com',
  'admin@test.com',
  'demo@demo.com',
  'lovable.dev',
];

export const TEST_NAME_PATTERNS = ['test', 'Test', 'TEST'];
export const ADMIN_NAMES = ['Noah Pittroff', 'Jonas', 'Konstantin'];

/**
 * Check if an account is a test/admin account based on email, customer name, and dog name.
 */
export function isTestAccount(params: {
  email?: string;
  customerName?: string;
  dogName?: string;
}): boolean {
  const { email = '', customerName = '', dogName = '' } = params;

  if (TEST_EMAILS.some(te => email.toLowerCase().includes(te.toLowerCase()))) {
    return true;
  }

  if (ADMIN_NAMES.some(name => customerName.includes(name))) {
    return true;
  }

  if (TEST_NAME_PATTERNS.some(pattern => dogName.includes(pattern))) {
    return true;
  }

  if (TEST_NAME_PATTERNS.some(pattern => customerName.toLowerCase().includes(pattern.toLowerCase()))) {
    return true;
  }

  return false;
}
